import React from 'react';
import { findIndex, find, sortBy } from 'lodash';

import {
  Modal,
  Button,
  FormControl,
  FormGroup,
  ControlLabel,
  Col,
  Row,
  Well
} from 'react-bootstrap';


import Tooltip from '../../../commonComponents/Tooltip';
import PagerUd from '../../../commonComponents/PagerUd';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';

import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
import { onFileDrop, onFileDelete } from '../../../commonComponents/onFileModify';
import CustPopover from '../../../commonComponents/CustPopover';
import DropDownMenu, { optsGenerator } from '../../../commonComponents/DropDownMenu';
import treeViewGenerator from '../../../commonComponents/treeViewGenerator';
import { getDefaultTableDataObj } from '../../../commonComponents/DataTable/DataTablePs';

import custJqAjax from '../../../commonJS/custJqAjax';
import autoFill from '../../../commonJS/autoFill';
import { getFileIdList } from '../../../commonJS/getFileName';
import parentStateHandler from '../../../commonJS/parentStateHandler';

const RequiredMark = props => <span style={{ color: "red" }}>* </span>;


export default class ProductModalCt extends React.Component {
  constructor(props) {
    super(props);
    this.handlers = {
      textAreaOnChange: e => {
        const jsInp = e.currentTarget,
          id = jsInp.id,
          value = jsInp.value;

        this.setState({
          [id]: value
        });
      },
      onInputFocus: e => {
        autoFill(e, this);
      },
      onChange: (selection, id, cb) => {
        const len = selection.length;
        switch (id) {
          case 'all_policy':
            const value = selection.value;
            this.setState({ all_policy: value });

            if (value === 0 && !this.state.optsUser.length) {
              // 取得user清單與group清單
              this.handlers.loadUsersAndGroups();
            }

            break;
          case 'all_policy_user_id_list':
          case 'all_policy_group_id_list':
          case 'arrRelatedProducts':
            const arr = [];
            for (let i = 0; i < len; i++) {
              arr.push(selection[i].value);
            }

            if (id === 'arrRelatedProducts' && !this.state.sholudUpdateRelatedProducts) {
              this.setState({ sholudUpdateRelatedProducts: true });
            }

            this.setState({
              [id]: arr
            });

            break;
          default:
        }
      },
      saveRelatedProducts: id => {
        const formData = new FormData();
        formData.append('model_id', id);
        formData.append('sub_id_list', this.state.arrRelatedProducts.join());

        custJqAjax({
          type: 'POST',
          url: '/api/W_salesky_product_list_relation_sort_replace.php',
          data: formData,
          processData: false,
          contentType: false,
          success: res => { }
        });
      },
      saveProduct: isUpdate => {
        let formData = new FormData(),
          id = isUpdate ? (this.props.selectedProductId || this.props.params.productId) : "",
          tw_data_list = `${this.state.price_tw}|${this.state.delivery_tw}|${this.state.characteristics_tw}|${this.state.appliance_tw}`,
          en_data_list = `${this.state.price_en}|${this.state.delivery_en}|${this.state.characteristics_en}|${this.state.appliance_en}`,
          cn_data_list = `${this.state.price_cn}|${this.state.delivery_cn}|${this.state.characteristics_cn}|${this.state.appliance_cn}`,
          ja_data_list = `${this.state.price_jp}|${this.state.delivery_jp}|${this.state.characteristics_jp}|${this.state.appliance_jp}`;

        formData.append('model_name', this.state.model_name);
        formData.append('tw_data_list', tw_data_list);
        formData.append('en_data_list', en_data_list);
        formData.append('cn_data_list', cn_data_list);
        formData.append('ja_data_list', ja_data_list);
        formData.append('all_policy', this.state.all_policy);
        formData.append('permission', this.state.permission);

        if (this.state.all_policy === 0) {
          formData.append('user_id_list', this.state.all_policy_user_id_list.join());
          formData.append('group_id_list', this.state.all_policy_group_id_list.join());
        }

        if (isUpdate) {
          formData.append('model_id', id);
        }

        custJqAjax({
          type: 'POST',
          url: `/api/W_SaleSky_ProductData_${isUpdate ? 'Update' : 'Post'}.php`,
          data: formData,
          processData: false,
          contentType: false,
          success: res => {
            // 執行儲存關聯產品api ===
            if (res.result.id || res.result.id === 0) {
              if (this.state.sholudUpdateRelatedProducts) {
                this.handlers.saveRelatedProducts(res.result.id);
              }
            }
            // ==========

            this.handlers.onProductModified(res.result, isUpdate ? 'update' : 'create');

            if ((this.state.categoryPath && this.state.categoryPathIds.length) || (this.state.orinPathIds && !this.state.categoryPathIds.length)) {
              // 前一個小括弧是新增和修改分類路徑時會成立
              // 有選過treeview或是新增時有傳入
              // this.state.categoryPathIds.length才會 > 0
              // 所以只有新增和修改關聯時才會成立

              // 後面的小括弧是刪除時會成立
              // 初始有路徑，儲存時無路徑，代表刪除

              let relationFormData = new FormData(),
                productId = res.result.id;

              const orinPathIdsArr = this.state.orinPathIds.split(',');

              if (this.state.orinPathIds && !this.state.categoryPathIds.length) {
                this.postOrUpdateProductRelation = 'Delete';

                relationFormData.append('path_id_list', orinPathIdsArr);
              } else {
                if (this.state.orinPathIds) {
                  this.postOrUpdateProductRelation = 'Update';
                  relationFormData.append('path_id_list_old', orinPathIdsArr);
                } else this.postOrUpdateProductRelation = "Post";

                relationFormData.append('path_id_list', this.state.categoryPathIds);
              }

              relationFormData.append('product_id', productId);

              const categoryPathIdsStr = this.state.categoryPathIds.join();
              if (this.state.orinPathIds !== categoryPathIdsStr) {
                // 有異動才call api
                // 建立分類路徑
                custJqAjax({
                  type: 'POST',
                  url: `/api/W_SaleSky_ProductData_Relation_${this.postOrUpdateProductRelation}.php`,
                  data: relationFormData,
                  processData: false,
                  contentType: false,
                  success: res => {
                    // 更新productCategories，新增產品連結
                    const categoryPathIds = this.postOrUpdateProductRelation === 'Delete'
                      ? orinPathIdsArr
                      : this.state.categoryPathIds;

                    let tarObj = this.treeViewFuncs.locator(categoryPathIds),
                      productInd = findIndex(tarObj.product_ids_sorts, { id: productId });

                    if (this.postOrUpdateProductRelation !== 'Delete') {
                      // 沒找到代表為新增或修改
                      tarObj.product_ids_sorts.push({ id: productId, sort: '0' });

                      // 更新treeview的刪除鈕狀態
                      if (tarObj.product_ids_sorts.length === 1) {
                        this.props.refreshTreeView();
                      }

                      if (this.postOrUpdateProductRelation === 'Update' && this.state.orinPathIds !== categoryPathIdsStr) {

                        // 從舊所屬分類中清除id
                        let oldTarObj = this.treeViewFuncs.locator(orinPathIdsArr),
                          oldProductInd = findIndex(oldTarObj.product_ids_sorts, { id: productId });

                        oldTarObj.product_ids_sorts.splice(oldProductInd, 1);

                        // 變更關聯後，當原分類已無任何產品，更新刪除鈕狀態
                        if (oldTarObj.product_ids_sorts.length === 0) {
                          this.props.refreshTreeView();
                        }

                        // for 修改路徑時即時更新table
                        this.props.updateProductTable(oldTarObj);
                      }

                    } else if (this.postOrUpdateProductRelation === 'Delete' && productInd !== -1) {
                      tarObj.product_ids_sorts.splice(productInd, 1);

                      if (tarObj.product_ids_sorts.length === 0) {
                        // 移除關聯後分類包含產品為0筆時更新treeview的刪除鈕狀態
                        this.props.refreshTreeView();
                      }
                    }

                    // productCategoies已變更，更新一下是需要的
                    this.props.stateHandler({ states: 'productCategories', newValues: this.props.productCategories })

                    // 如果變更的是作用中分類的產品，則更新table

                    const effectedPath = this.state.categoryPathIds.length ? categoryPathIdsStr : orinPathIdsArr.join();

                    if (effectedPath === this.props.selectedTrackIds.join()) {
                      this.props.updateProductTable(tarObj);
                    }

                    this.props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
                  }
                });
              }
            }

            // 處理上傳檔案
            this.fileWorker(true, res.result.id);

            // 處理update的檔案刪除動作
            if (isUpdate) {
              this.fileWorker(undefined, res.result.id);
            }

            // 如果完全沒有執行檔案相關作業，會需要從這裡關閉
            if (this.filesWip < 1) {

              if (this.state.sholudUpdateFilesSort) {
                this.updateFilesSort(this.fileSorts, id);
              }

              this.props.closeModal();
            }

            // 更新搜尋結果
            this.props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
          }
        });
      },
      deleteProduct: () => {
        let formData = new FormData(),
          id = this.props.selectedProductId;

        formData.append('model_id', id);

        custJqAjax({
          type: 'POST',
          url: '/api/W_SaleSky_ProductData_Delete.php',
          data: formData,
          processData: false,
          contentType: false,
          success: data => {
            const selectedProduct = find(this.props.productOrinData, { id });

            if (this.props.activeCateObj) {
              const tarObj = this.props.activeCateObj || this.props.productCategories;
              let productInd = findIndex(tarObj.product_ids_sorts, { id });

              if (productInd !== -1) {
                tarObj.product_ids_sorts.splice(productInd, 1);

                if (tarObj.product_ids_sorts.length === 0) {
                  // 移除關聯後分類包含產品為0筆時更新treeview的刪除鈕狀態
                  this.props.refreshTreeView();
                }
                // productCategoies已變更，更新一下是需要的
                this.props.stateHandler({ states: 'productCategories', newValues: this.props.productCategories })
              }
            }

            this.handlers.onProductModified(selectedProduct, 'delete');
            this.props.closeModal({ isDeletion: true });
            this.props.parentStateHandler({ states: 'doSearchUpdate', newValues: 1 });
          }
        });
      },
      onProductModified: (data, mode) => {
        // 更新productOrinData, productSortedData
        let productOrinData = this.props.productOrinData,
          productSortedData = "",
          newProduct = {
            id: data.id,
            name: data.model_name
          };

        if (mode === "create") {
          productOrinData.unshift(newProduct);
          if (this.props.activeCateObj) {
            this.props.updateProductTable(this.props.activeCateObj);
          } else {
            productSortedData = getDefaultTableDataObj(productOrinData);
          }
        } else if (mode === "update") {
          let updateInd = findIndex(productOrinData, { id: data.id });
          productOrinData[updateInd] = newProduct;
          if (this.props.activeCateObj) {
            this.props.updateProductTable(this.props.activeCateObj);
          }
        } else if (mode === "delete") {
          let updateInd = findIndex(productOrinData, { id: data.id });

          productOrinData.splice(updateInd, 1);
          if (this.props.activeCateObj) {
            this.props.updateProductTable(this.props.activeCateObj);
          } else {
            productSortedData = getDefaultTableDataObj(productOrinData);
          }
        }

        if (productSortedData) {
          this.props.stateHandler({ states: ['productOrinData', 'productSortedData'], newValues: [productOrinData, productSortedData] });
        } else {
          this.props.stateHandler({ states: 'productOrinData', newValues: productOrinData });
        }

      },
      getValidationState: value => (value === 'default' || !value) ? 'error' : null,
      onEditClick: () => {
        this.setState({ onEdit: true, onCopy: false, editMode: "Edit", selContactDisable: false })
      },
      onCopyClick: () => {
        // 重置
        this.fileSorts = {
          img: [],
          pdf: [],
          video: []
        };

        this.setState({
          // 使關聯產品可延用
          sholudUpdateRelatedProducts: true,
          // 使產品分類可延用
          orinPathIds: '',
          //
          onCopy: true, onEdit: false, editMode: "Copy",
          selContactDisable: false,
          // clear files
          downloadedFiles: [],
          downloadedImgs: [],
          downloadedPDFs: [],
          downloadedVideos: [],
          previewsImg: [],
          previewsPDF: [],
          previewsVideo: []
        });
      },
      loadUsersAndGroups: () => {
        // load users
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: '/api/M_SaleSky_Users.php',
          success: data => {
            if (data.result) {
              let optsUser = optsGenerator(data.result);
              this.setState({ optsUser });
            }
          }
        });
        // load groups
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: '/api/M_SaleSky_UserGroup.php',
          success: data => {
            if (data.result) {
              let optsGroup = optsGenerator(data.result);
              this.setState({ optsGroup });
            }
          }
        });
      },
      getRelatedProducts: id => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_Product_List_Relation_Get.php?model_id=${id}`,
          processData: false,
          contentType: false,
          success: res => {
            switch (res.status) {
              case '0':
                // 產生關聯產品id arr
                const len = res.result.length;

                let arrRelatedProducts = [];
                // sort轉數字
                for (let i = 0; i < len; i++) {
                  res.result[i].sort_id = parseInt(res.result[i].sort_id, 10);
                }
                // 排序
                const sortedArr = sortBy(res.result, ['sort_id']);
                // 產生id arr
                for (let i = 0; i < len; i++) {
                  arrRelatedProducts[i] = sortedArr[i].sub_id;
                }

                this.setState({ arrRelatedProducts });
                break;
              case '204':
                return;
              default:
            }
          }
        });
      },
      loadProductData: (id, cb) => {
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_ProductData_GetAll.php?id=${id}`,
          processData: false,
          contentType: false,
          success: res => {
            if (!res.result.id) return;
            const data = res.result,
              orinFiles = data.images.concat(data.pdfs).concat(data.videos);

            let downloadedFiles = this.fileFilter(orinFiles),
              langDataTW = '',
              langDataEN = '',
              langDataCN = '',
              langDataJP = '';

            if (data.lang_data['zh-tw']) {
              langDataTW = {
                price_tw: data.lang_data['zh-tw'].price,
                delivery_tw: data.lang_data['zh-tw'].delivery,
                characteristics_tw: data.lang_data['zh-tw'].characteristic,
                appliance_tw: data.lang_data['zh-tw'].appliance
              }
            }

            if (data.lang_data['en']) {
              langDataEN = {
                price_en: data.lang_data['en'].price,
                delivery_en: data.lang_data['en'].delivery,
                characteristics_en: data.lang_data['en'].characteristic,
                appliance_en: data.lang_data['en'].appliance
              }
            }

            if (data.lang_data['zh-cn']) {
              langDataCN = {
                price_cn: data.lang_data['zh-cn'].price,
                delivery_cn: data.lang_data['zh-cn'].delivery,
                characteristics_cn: data.lang_data['zh-cn'].characteristic,
                appliance_cn: data.lang_data['zh-cn'].appliance
              }
            }

            if (data.lang_data['ja']) {
              langDataJP = {
                price_jp: data.lang_data['ja'].price,
                delivery_jp: data.lang_data['ja'].delivery,
                characteristics_jp: data.lang_data['ja'].characteristic,
                appliance_jp: data.lang_data['ja'].appliance
              }
            }

            const all_policy = (data.user_id_list.length || data.group_id_list.length) ? 0 : 1;
            if (!all_policy) {
              this.handlers.loadUsersAndGroups();
            }

            const path_id_list = data.path_id_list[0];

            this.setState({
              // product
              ...langDataTW,
              ...langDataEN,
              ...langDataCN,
              ...langDataJP,
              model_name: data.model_name,
              permission: 2,
              all_policy: all_policy,
              all_policy_user_id_list: data.user_id_list,
              all_policy_group_id_list: data.group_id_list,
              categoryPathIds: path_id_list ? path_id_list.split(',') : [], // 先處理單筆歸屬的情況，後續確認後再調整
              orinPathIds: path_id_list || ""
            });

            if (cb) cb(path_id_list);

            // for downloaded files that uploaded before
            this.onFileDrop(downloadedFiles);
          }
        });

        // 抓取關聯產品
        this.handlers.getRelatedProducts(id);
      },
      rowIndexCheck: () => {
        // 預防使用者在modal重新整理，導致無selectedRowIndex，造成上一筆下一筆功能異常
        if (this.props.params && this.props.params.productId && !this.props.selectedRowIndex) {
          // 初始狀態的ind和indexMap是一樣的
          let id = this.props.params.productId,
            ind = findIndex(this.props.productSortedData._data, { id });

          this.props.parentStateHandler({
            states: ['selectedProductId', 'selectedRowIndex'],
            newValues: [id, ind]
          });

          return ind;
        }
        return this.props.selectedRowIndex;
      },
      loadNewProduct: () => {
        let productId = this.props.params.productId;

        this.handlers.loadProductData(productId, path_id_list => {
          if (path_id_list) this.treeViewFuncs.runPath(path_id_list);
        });
      },
      changeProduct: () => {
        this.handlers.loadNewProduct();
        this.funcs.optsProductGen();
      },
      onPreviousClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex - 1),
          rowIndex = r >= 0 ? r : 0;
        if (rowIndex !== selectedRowIndex) {
          // let id = this.props.productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, this.props.productSortedData);
          // this.handlers.loadProductData(id);

          // load new Product
          this.funcs.resetState(this.handlers.changeProduct);
        }
      },
      onNextClick: () => {
        let selectedRowIndex = this.handlers.rowIndexCheck(),
          r = (selectedRowIndex + 1),
          productSortedData = this.props.productSortedData,
          max = productSortedData.getSize(),
          rowIndex = r < max ? r : (max - 1);
        if (rowIndex !== selectedRowIndex) {
          // let id = productSortedData.getObjectAt(rowIndex).id;
          this.props.onRowClick("e", rowIndex, productSortedData);
          // this.handlers.loadProductData(id);

          // load new Product
          this.funcs.resetState(this.handlers.changeProduct);
        }
      },
      onPopoverCloseClick: e => {
        document.getElementById('categoryPath').click();

        e.stopPropagation();
      }
    };

    this.funcs = {
      optsProductGen: id => {
        let productList = this.props.productOrinData.slice();

        if (this.props.params && this.props.params.productId) {
          let productId;
          if (id || id === 0) {
            productId = id;
          } else {
            productId = this.props.params.productId;
          }

          const ind = findIndex(productList, { id: productId });
          // 從清單移除自身
          productList.splice(ind, 1);
        }

        this.setState({
          optsProduct: optsGenerator(productList)
        });
      },
      resetState: cb => {

        this.uploadedFiles = [];

        this.fileSorts = {
          img: [],
          pdf: [],
          video: []
        };

        this.setState({
          // product
          model_name: "",
          price_tw: "",
          price_en: "",
          price_cn: "",
          price_jp: "",
          delivery_tw: "",
          delivery_en: "",
          delivery_cn: "",
          delivery_jp: "",
          characteristics_tw: "",
          characteristics_en: "",
          characteristics_cn: "",
          characteristics_jp: "",
          appliance_tw: "",
          appliance_en: "",
          appliance_cn: "",
          appliance_jp: "",
          all_policy: 1,
          permission: 2,
          optsUser: [],
          optsGroup: [],
          optsProduct: [],
          all_policy_user_id_list: [],
          all_policy_group_id_list: [],
          arrRelatedProducts: [],
          sholudUpdateRelatedProducts: false,
          // for treeView
          orinPathIds: '', // didmount時抓取之後就不變更
          categoryPath: '', // 分類路徑文字
          categoryPathIds: [],
          collapsesState: {},
          selectedTracks: [], // [0], 關聯預設應是無作用中分類
          productTreeView: [],
          showTreeView: false,
          // file crud 相關 ====================
          downloadedFiles: [],
          downloadedImgs: [],
          downloadedPDFs: [],
          downloadedVideos: [],
          previewsImg: [],
          previewsPDF: [],
          previewsVideo: [],
          deletedDownloadedFiles: [],
          fileWorkInProgress: false, // 控制檔案上傳進度用
          // ====================
          // common
          btnSaveDisable: true,
          btnDeleteDisable: true,
          onEdit: false,
          onCopy: false,
          editMode: "View",
          editPermission: true
        }, cb ? cb : "");
      }
    };

    this.parentStateHandler = ({ states, newValues }) => {
      parentStateHandler({ states, newValues, parentThis: this });
    };

    this.ajaxsWip = [];

    // file crud相關 ===========
    // for file upload，不需渲染的資料不使用state，避免多餘的render check
    this.uploadedFiles = [];
    this.fileSorts = {
      img: [],
      pdf: [],
      video: []
    };

    this.updateFilesSort = (objSortedNameURL, productId) => {
      // 更新檔案排序
      let postData = new FormData();
      postData.append('id', productId);
      postData.append('type', 'Product');
      postData.append('file_id_list', getFileIdList(objSortedNameURL).join());

      custJqAjax({
        type: 'POST',
        url: '/api/W_SkyFamily_System_Extra_Files_Sort_Update.php',
        data: postData,
        processData: false,
        contentType: false,
        complete: () => { }
      });

    };

    // for downloaded files that uploaded before
    this.onFileDrop = downloadedFiles => {
      onFileDrop(downloadedFiles, '', this, true, false, true, this.fileSorts, this.parentStateHandler);
    };

    this.onFileDelete = (type, fileName) => {
      // onFileDelete是在onFileDrop裡面會被使用，
      // type, fileName在裡面預設會傳入

      // 編輯模式下remove icon才有效
      let productId = "";
      if (this.props.params) productId = this.props.params.productId;

      if (this.state.editMode !== "View" || !productId) {
        onFileDelete(type, fileName, this, true, this.fileSorts);
      } else {
        return;
      }

    };

    // 配合api
    this.fileFilter = orinFiles => {
      // 檔案預處理
      let name = "", dotInd = "", type = "";

      const downloadedFiles = orinFiles.map((item, ind) => {
        name = item.file_name;
        dotInd = name.lastIndexOf('.');
        type = name.slice(dotInd + 1);

        switch (type) {
          case 'jpg':
            item.type = 'image/jpeg';
            break;
          case 'png':
            item.type = 'image/png';
            break;
          case 'svg':
            item.type = 'image/svg+xml';
            break;
          case 'pdf':
            item.type = 'application/pdf';
            break;
          case 'mp4':
            item.type = 'video/mp4';
            break;
          default:
        }

        return item;

      });

      return downloadedFiles;
    };

    this.fileWorker = (isUpload, fileId) => {
      let fileData = new FormData(),
        requiredField = 'id',
        apiType = 'M',
        apiKeyWord = 'Delete',
        len = this.state.deletedDownloadedFiles.length;

      if (isUpload) {
        requiredField = '$_FILES';
        apiType = 'W';
        apiKeyWord = 'Upload';
        len = this.uploadedFiles.length;
        fileData.append('file_id', fileId);
      }

      // api只支援一次傳一個檔，要用迴圈處理
      if (len > 0) {
        this.filesWip += len;
        if (!this.state.fileWorkInProgress) this.setState({ fileWorkInProgress: true });

        fileData.append('type', 'Product');

        // do not make functions in a loop;
        let printRes = (res, uploadedFileName, uploadedFileType) => {
          // 比對結果確認更新file name需求
          if (uploadedFileName) {

            if (uploadedFileType.indexOf('image') !== -1) {
              this.fileSorts.img[this.fileSorts.img.indexOf(uploadedFileName)] = res.responseJSON.result.id; // pure file id
            } else if (uploadedFileType.indexOf('pdf') !== -1) {
              this.fileSorts.pdf[this.fileSorts.pdf.indexOf(uploadedFileName)] = res.responseJSON.result.id; // pure file id
            } else if (uploadedFileType.indexOf('video') !== -1) {
              this.fileSorts.video[this.fileSorts.video.indexOf(uploadedFileName)] = res.responseJSON.result.id; // pure file id
            }

          }

          this.filesWip -= 1;
          if (this.filesWip < 1) {
            this.setState({ fileWorkInProgress: false });
            // 更新file sort

            this.updateFilesSort(this.fileSorts, fileId);

            this.props.closeModal();
          }
        };

        for (let i = 0; i < len; i++) {
          let value = "", uploadedFileName, uploadedFileType;
          if (isUpload) {
            value = this.uploadedFiles[i];
            uploadedFileName = value.name;
            uploadedFileType = value.type;
          } else {
            let fileName = this.state.deletedDownloadedFiles[i].file_name,
              backslashInd = fileName.lastIndexOf('/'),
              dotInd = fileName.lastIndexOf('.'),
              fileId = fileName.slice(backslashInd + 1, dotInd);

            value = fileId;
          }

          fileData.append(requiredField, value);
          custJqAjax({
            type: 'POST',
            url: `/api/${apiType}_SaleSky_File${apiKeyWord}_Post.php`,
            data: fileData,
            processData: false,
            contentType: false,
            complete: res => { printRes(res, uploadedFileName, uploadedFileType); }
          });
        }
      }
    };

    // 控制檔案上傳進度用
    this.filesWip = 0;

    // ======================

    // treeView funcs
    this.treeViewFuncs = {
      runPath: pathIdListStr => {
        // productCt抓根目錄尚未完成情況下，待機
        if (!this.props.productCategories.id) {
          this.timer = setTimeout(() => { this.treeViewFuncs.runPath(pathIdListStr); }, 500);
          return;
        }

        const pathIdListArr = pathIdListStr.split(','),
          len = pathIdListArr.length;

        let count = 0,
          parentObj = this.props.productCategories,
          selectedTracks = [0],
          selectedTrackNames = ['所有產品'],
          selectedTrackIds = ['0'];

        const repeater = (parentObj, selectedTracks, selectedTrackNames, selectedTrackIds) => {
          const promise = new Promise((resolve, reject) => {
            this.treeViewFuncs.onTreeViewNodeClick(parentObj, selectedTracks, selectedTrackNames, selectedTrackIds, resolve);
          });

          promise.then(res => {
            count++;
            if (count < len) {
              let ind = 0,
                name = "";

              if (count === 1) {
                ind = findIndex(parentObj.product_category_ids_sorts, { id: pathIdListArr[count] });
                name = parentObj.product_category_ids_sorts[ind].name_tw || 'No name';
              } else {
                parentObj = find(parentObj.product_category_ids_sorts, { id: pathIdListArr[count - 1] });
                ind = findIndex(parentObj.product_category_ids_sorts, { id: pathIdListArr[count] });
                name = parentObj.product_category_ids_sorts[ind].name_tw || 'No name';
              }

              selectedTracks.push(ind);
              selectedTrackIds.push(pathIdListArr[count]);
              selectedTrackNames.push(name);

              repeater(parentObj, selectedTracks, selectedTrackNames, selectedTrackIds);
            }

            return;
          });
        };

        repeater(parentObj, selectedTracks, selectedTrackNames, selectedTrackIds);
      },
      removeRelation: () => {
        this.setState({ categoryPathIds: [], categoryPath: '', collapsesState: {}, selectedTracks: [] });
        this.treeViewFuncs.refreshTreeView();
      },
      onTreeViewNodeClick: (parentObj, selectedTracks, selectedTrackNames, selectedTrackIds, resolve) => {
        // 更新路徑
        const len = selectedTrackNames.length;
        let categoryPath = "";
        for (let i = 0; i < len; i++) {
          categoryPath += selectedTrackNames[i] + ' / ';
        }

        // 更新treeview
        const lastPos = selectedTracks.length - 1;

        let collapses = this.state.collapsesState,
          productCategories = this.props.productCategories,
          collapseKey = selectedTrackIds[lastPos];

        collapses[collapseKey] = resolve ? false : !collapses[collapseKey];

        const { productTreeView, collapsesState } = treeViewGenerator(productCategories, collapses, this.treeViewFuncs.onTreeViewNodeClick, selectedTrackIds[lastPos], '', '', 'name_tw'),
          ind = selectedTracks[lastPos];

        // 離開即重置的狀態由this管理
        this.setState({ collapsesState, selectedTracks, productTreeView, categoryPath, categoryPathIds: selectedTrackIds });

        // 是否抓取新資料
        // const tarObj = this.treeViewFuncs.locator(productCategories, selectedTracks),
        const tarObj = (lastPos === 0 ? parentObj : parentObj.product_category_ids_sorts[ind]),
          childCategories = tarObj.product_category_ids_sorts;

        if (childCategories.length && !childCategories[0].product_category_ids_sorts) {
          let len = childCategories.length;

          this.categoriesWip += len;
          for (let i = 0; i < len; i++) {
            this.treeViewFuncs.loadCategoryData(childCategories, i, resolve);
          }

        } else {
          if (resolve) resolve('cateAjaxAllDone');
        }

      },
      locator: arrTrackIds => {
        const len = arrTrackIds.length;

        // 定位目標物件
        if (len) {
          let tempA = this.props.productCategories,
            tempB = {};


          for (let i = 1; i < len; i++) {
            tempB = tempA;
            tempA = find(tempB.product_category_ids_sorts, { id: arrTrackIds[i] });
          }

          return tempA;
        }

      },
      dataTranslator: resData => {
        let nodeObj = {};

        // 轉譯為標準格式
        nodeObj.id = resData.id;
        nodeObj.name_tw = resData.name_tw;
        nodeObj.name_en = resData.name_en;
        nodeObj.name_cn = resData.name_cn;
        nodeObj.name_ja = resData.name_ja;
        nodeObj.product_category_ids_sorts = resData.product_category_ids_sorts;
        nodeObj.product_ids_sorts = resData.product_ids_sorts;
        nodeObj.sort = resData.sort ? parseInt(resData.sort, 10) : "";

        return nodeObj;
      },
      loadCategoryData: (childCategories, sort, resolve) => {
        const id = childCategories ? childCategories[sort].id : 0;
        custJqAjax({
          type: 'GET',
          ajaxsWip: this.ajaxsWip,
          custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
          url: `/api/W_SaleSky_ProductCategories_Lang_Get.php?id=${id}`,
          complete: res => {
            this.categoriesWip -= 1;
            if (this.categoriesWip < 1 && resolve) {
              resolve('cateAjaxAllDone');
            }
          },
          success: res => {
            let productCategories = this.props.productCategories,
              nodeObj = this.treeViewFuncs.dataTranslator(res.result);
            // childCategories = [];

            // childCategories是productCategoreis裡面的一個key參照到的arr
            // 所以改變此arr，連帶也會改變productCategories的內容

            // 分類預排序
            const childCate = sortBy(nodeObj.product_category_ids_sorts, ['sort']);
            nodeObj.product_category_ids_sorts = childCate;

            if (!productCategories.id) {
              productCategories = nodeObj;
            } else {
              // childCategories = this.treeViewFuncs.locator(productCategories, this.state.selectedTracks).product_category_ids_sorts;
              childCategories.splice(sort, 1, nodeObj);
            }



            const pos = this.state.categoryPathIds.length - 1,
              activeId = pos === -1 ? "" : this.state.categoryPathIds[pos],
              { productTreeView, collapsesState } = treeViewGenerator(productCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, activeId, '', '', 'name_tw');

            this.setState({ collapsesState, productTreeView });

            this.props.stateHandler({
              states: 'productCategories',
              newValues: productCategories
            });

          }
        });
      },
      toggleTreeView: e => {
        e.stopPropagation();

        if (this.state.productTreeView.length === 0) {
          const pos = this.state.categoryPathIds.length - 1,
            activeId = pos === -1 ? "" : this.state.categoryPathIds[pos],
            { productTreeView, collapsesState } = treeViewGenerator(this.props.productCategories, this.state.collapsesState, this.treeViewFuncs.onTreeViewNodeClick, activeId, '', '', 'name_tw');

          this.setState({ collapsesState, productTreeView });
        }

        // 同一個func裡面的多個setState會整合成一次
        this.setState({ showTreeView: !this.state.showTreeView });

      },
      refreshTreeView: () => {

        const { productTreeView, collapsesState } = treeViewGenerator(this.props.productCategories, {}, this.treeViewFuncs.onTreeViewNodeClick, '', '', '', 'name_tw');

        this.setState({ collapsesState, productTreeView });

      }
    }

    // 判斷product relation更新時應用何種方法
    this.postOrUpdateProductRelation = 'Post';

    // 控制分類get api ajax完成度
    this.categoriesWip = 0;

    // setTimeout Id
    this.timer = "";


    this.state = {
      // product
      model_name: "",
      price_tw: "",
      price_en: "",
      price_cn: "",
      price_jp: "",
      delivery_tw: "",
      delivery_en: "",
      delivery_cn: "",
      delivery_jp: "",
      characteristics_tw: "",
      characteristics_en: "",
      characteristics_cn: "",
      characteristics_jp: "",
      appliance_tw: "",
      appliance_en: "",
      appliance_cn: "",
      appliance_jp: "",
      all_policy: 1,
      permission: 2,
      optsUser: [],
      optsGroup: [],
      optsProduct: [],
      all_policy_user_id_list: [],
      all_policy_group_id_list: [],
      arrRelatedProducts: [],
      sholudUpdateRelatedProducts: false,
      // for treeView
      orinPathIds: '', // didmount時抓取之後就不變更
      categoryPath: '', // 分類路徑文字
      categoryPathIds: [],
      collapsesState: {},
      selectedTracks: [], // [0], 關聯預設應是無作用中分類
      productTreeView: [],
      showTreeView: false,
      // file crud 相關 ====================
      downloadedFiles: [],
      downloadedImgs: [],
      downloadedPDFs: [],
      downloadedVideos: [],
      previewsImg: [],
      previewsPDF: [],
      previewsVideo: [],
      deletedDownloadedFiles: [],
      fileWorkInProgress: false, // 控制檔案上傳進度用
      forceUpdate: true,
      sholudUpdateFilesSort: false, // 判斷是否需call sort api
      // ====================
      // common
      btnSaveDisable: true,
      btnDeleteDisable: true,
      onEdit: false,
      onCopy: false,
      editMode: "View",
      editPermission: true
    };
  }


  componentDidMount() {

    if (this.props.params && this.props.params.productId) {
      this.handlers.loadNewProduct();
    } else {
      document.getElementById('model_name').focus();
      this.setState({
        categoryPath: this.props.categoryPath,
        categoryPathIds: this.props.selectedTrackIds,
        selectedTracks: this.props.selectedTracks,
        collapsesState: this.props.collapsesState
      });
    }

    // 產生關聯產品選項
    this.funcs.optsProductGen();

  }

  componentDidUpdate(prevProps, prevState) {
    // didmount後product data ajax尚未完成的情況下產生關聯產品選項
    if (prevProps.productOrinData !== this.props.productOrinData) {
      // means get products ajax was done.
      this.funcs.optsProductGen();
    }

    // 資料驗證ok才可送出
    if (this.state.model_name === '' || (!this.state.all_policy && !this.state.all_policy_user_id_list.length && !this.state.all_policy_group_id_list.length)) {

      if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });
    } else if (this.state.btnSaveDisable) this.setState({ btnSaveDisable: false });
  }

  componentWillUnmount() {
    this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
    clearTimeout(this.timer);
  }

  render() {
    let saveBtn = "",
      deleteBtn = "",
      editable = 0,
      modeBtns = "",
      productId = "",
      pagerUd = "",
      saveBtnText = this.state.fileWorkInProgress ? '檔案上傳中...' : '儲存';

    if (this.props.params) productId = this.props.params.productId;
    // else  productId = this.props.productId;

    if (this.state.editMode !== "View" || !productId) {
      saveBtn = (
        <Button disabled={this.state.btnSaveDisable}
          onClick={() => { this.handlers.saveProduct(this.state.onEdit ? 1 : 0) }}
          style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
          {saveBtnText}
        </Button>
      );
      editable = 1;
    } else {
      const permission = this.state.editPermission;
      let tipText = "";

      // if(!permission) {
      //   if(this.props.userId !== this.state.calendarOwnerId) tipText = "Only the creater is allowed to edit.";
      // else tipText = "You are allowed to edit logs which are created today";
      // }

      modeBtns = (
        <span>
          <Button
            onClick={this.handlers.onCopyClick}
            style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
            複製
          </Button>
          <Button
            disabled={!permission}
            onClick={this.handlers.onEditClick}
            style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>
            編輯
            {permission ? "" : <Tooltip tipText={tipText} placement="left" />}
          </Button>
        </span>
      );

      pagerUd = <PagerUd style={{ position: "absolute", width: "100%", marginTop: 0, marginBottom: 0, marginLeft: -15, fontSize: 14, padding: "1px 0" }}
        onPreviousClick={this.handlers.onPreviousClick}
        onNextClick={this.handlers.onNextClick} />;

    }

    deleteBtn = this.state.onEdit ?
      <DeleteBtnWithConfirm
        style={{ float: "right", marginLeft: 5, position: "relative", zIndex: "3" }}
        onClick={this.handlers.deleteProduct}
        title="Are you sure?" />
      : "";

    const { previewsImg, previewsPDF, previewsVideo } = this.state,
      downloadedFilesPreview = { previewsImg, previewsPDF, previewsVideo },
      // showRemoveRelation = (this.state.categoryPath && this.props.params && this.props.params.productId),
      showRemoveRelation = this.state.categoryPath,
      popoverContent = <div id='popover-tree-view-container' style={{ overflow: 'auto' }}>{this.state.productTreeView}</div>,
      dropDownValidation = (this.state.all_policy || (this.state.all_policy_user_id_list.length || this.state.all_policy_group_id_list.length)) ? null : 'error';


    return (
      <Modal id="modal-product" keyboard={false} backdrop="static" show={true} onHide={this.props.closeModal} bsSize="large">
        <Modal.Header>
          <Modal.Title>
            <span style={{ padding: "6px 0px", height: 34, lineHeight: '34px' }}>
              {
                productId ?
                  <span style={{ float: "left" }}>
                    <span style={{ color: "rgba(0, 0, 200, .7" }}>{this.state.editMode}</span> Mode
                </span> :
                  <span>
                    New Product
                </span>
              }
            </span>
            <Button onClick={this.props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
            {saveBtn}
            {modeBtns}
            {deleteBtn}
            {pagerUd}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <Row>
            <Col sm={12}>
              <FormGroup controlId="model_name"
                validationState={this.state.model_name ? null : 'error'}>
                <ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />產品名稱</ControlLabel>
                <FormControl
                  disabled={!editable}
                  type='text'
                  onChange={this.handlers.textAreaOnChange}
                  value={this.state.model_name}
                  style={{ height: 36 }} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <FormGroup controlId="categoryPath" style={{ position: 'relative' }}>
                {showRemoveRelation ? <Button id="btn-remove-relation" disabled={!editable} onClick={this.treeViewFuncs.removeRelation}>清除此關聯</Button> : ""}
                <ControlLabel style={{ fontWeight: 'bold' }}>所屬產品分類路徑 (點擊以選擇。)</ControlLabel>
                <CustPopover
                  trigger={
                    <FormControl
                      disabled={!editable}
                      type='text'
                      onClick={this.treeViewFuncs.toggleTreeView}
                      value={this.state.categoryPath}
                      style={{ height: 36 }} />
                  }
                  title={
                    <div style={{ position: 'relative', height: 34, lineHeight: '34px' }}>
                      <span>選擇下方分類以建立分類路徑</span>
                      <Button onClick={this.handlers.onPopoverCloseClick} style={{ position: 'absolute', right: 0, top: 0 }}>關閉</Button>
                    </div>
                  }
                  content={popoverContent}
                  placement="bottom"
                  id='popover-product-category'>

                </CustPopover>
              </FormGroup>
            </Col>
          </Row>

          <Row id='row-related-products'>

            <DropDownMenu
              multi={true}
              sm={12}
              disabled={!editable}
              label="關聯產品 (可多選。)"
              value={this.state.arrRelatedProducts}
              stateName="arrRelatedProducts"
              onChange={this.handlers.onChange}
              options={this.state.optsProduct} />

          </Row>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}>產品特色</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup controlId="characteristics_tw">
                <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.characteristics_tw} onChange={this.handlers.textAreaOnChange} componentClass="textarea" placeholder="Write descriptions here" />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}>應用範圍</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup controlId="appliance_tw">
                <FormControl onFocus={this.handlers.onInputFocus} disabled={!editable} value={this.state.appliance_tw} onChange={this.handlers.textAreaOnChange} componentClass="textarea" placeholder="Write descriptions here" />
              </FormGroup>
            </Col>
          </Row>

          {/* Price */}

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}>定價</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup controlId="price_tw">
                <FormControl
                  disabled={!editable}
                  type='text'
                  onFocus={this.handlers.onInputFocus}
                  onChange={this.handlers.textAreaOnChange}
                  value={this.state.price_tw}
                  style={{ height: 36 }} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}>交期</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <FormGroup controlId="delivery_tw">
                <FormControl
                  disabled={!editable}
                  type='text'
                  onFocus={this.handlers.onInputFocus}
                  onChange={this.handlers.textAreaOnChange}
                  value={this.state.delivery_tw}
                  style={{ height: 36 }} />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}>瀏覽權限</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well>
                <Row>
                  <DropDownMenu
                    sm={12}
                    disabled={!editable}
                    required={false}
                    label="全部 / 部分 開放"
                    value={this.state.all_policy}
                    stateName="all_policy"
                    onChange={this.handlers.onChange}
                    options={[{ value: 0, label: '部分' }, { value: 1, label: '全部' }]} />
                </Row>
                {
                  this.state.all_policy ?
                    ""
                    :
                    <Row>
                      <DropDownMenu
                        sm={6}
                        disabled={!editable}
                        required={false}
                        label="Member"
                        multi={true}
                        validationState={dropDownValidation}
                        value={this.state.all_policy_user_id_list}
                        stateName="all_policy_user_id_list"
                        optsOnLoading={!this.state.optsUser.length}
                        onChange={this.handlers.onChange}
                        options={this.state.optsUser} />

                      <DropDownMenu
                        sm={6}
                        disabled={!editable}
                        label="Department"
                        multi={true}
                        validationState={dropDownValidation}
                        value={this.state.all_policy_group_id_list}
                        stateName="all_policy_group_id_list"
                        optsOnLoading={!this.state.optsGroup.length}
                        onChange={this.handlers.onChange}
                        options={this.state.optsGroup} />
                    </Row>
                }
              </Well>
            </Col>
          </Row>

          <Row>
            <Col sm={12}>
              <div style={{ fontWeight: "bold" }}>附件 (於編輯模式可拖曳改變排序。)</div>
            </Col>
          </Row>
          <Row>
            <Col sm={12}>
              <Well style={{ margin: 0 }}>
                <FileDropAreaCt
                  parentStateHandler={this.parentStateHandler}
                  fileSorts={this.fileSorts}
                  disabled={!editable}
                  enableDnd={true}
                  containerThis={this}
                  uploadedFiles={this.uploadedFiles}
                  downloadedFilesPreview={downloadedFilesPreview} />
              </Well>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          {pagerUd}
          <Button onClick={this.props.closeModal} style={{ float: 'right', marginLeft: 5, position: "relative", zIndex: "3" }}>取消</Button>
          {saveBtn}
          {deleteBtn}
        </Modal.Footer>
      </Modal>
    );
  }
}


// WEBPACK FOOTER //
// ./src/salesky/routes/product/ProductModalCt.jsx